import createApiClient from "./api";
import { convertRole } from "../utils/textUtils";

const api = createApiClient();

export const createProject = async (projectData) => {
  const token = localStorage.getItem("token");
  const response = await api.post("/projects", projectData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchProjectUsers = async (
  projectId,
  page = 1,
  pageSize = 1000,
  filters = {},
  sortField = null,
  sortOrder = null
) => {
  const token = localStorage.getItem("token");
  const params = {
    skip: (page - 1) * pageSize,
    limit: pageSize,
  };
  if (filters && Object.keys(filters).length > 0) {
    params.filters = JSON.stringify(filters);
  }
  if (sortField && sortOrder) {
    params.sort_field = sortField;
    params.sort_order = sortOrder;
  }
  const response = await api.get(`/projects/${projectId}/users`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  let users = response.data.data; // Assuming backend returns { data: [...users], total: number }
  users = users.map((element) => {
    return {
      ...element,
      formatted_role: convertRole(element?.role),
    };
  });

  return {
    data: users,
    total: response.data.total,
  };
};

export const inviteUser = async (data) => {
  const token = localStorage.getItem("token");
  const response = await api.post("/projects/invite", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const removeUser = async (projectId, userId) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(
    `/projects/${projectId}/members/${userId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const fetchInvitations = async () => {
  const token = localStorage.getItem("token");

  // Return empty array if no token exists
  if (!token) {
    return [];
  }

  const response = await api.get("/projects/invitations", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const acceptInvitation = async (invitationId) => {
  const token = localStorage.getItem("token");
  const response = await api.post(
    `/projects/accept-invitation?invitation_id=${invitationId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateUserRoleVendor = async (projectId, userId, data) => {
  const token = localStorage.getItem("token");
  const response = await api.put(
    `/projects/${projectId}/users/${userId}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateProject = async (projectId, values) => {
  const token = localStorage.getItem("token");
  const response = await api.put(`/projects/${projectId}`, values, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const archiveProject = async (projectId, archived) => {
  const token = localStorage.getItem("token");
  const response = await api.patch(
    `/projects/${projectId}/archive`,
    { archived },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const requestProjectExport = async (projectId) => {
  const token = localStorage.getItem("token");
  const response = await api.post(
    `/exports/${projectId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const fetchProjectExportDownload = async (projectId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/exports/${projectId}/download`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteProject = async (projectId) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(`/projects/${projectId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const createPremiumProject = async (projectData) => {
  const token = localStorage.getItem("token");
  const response = await api.post(
    "/projects/create-premium-project",
    projectData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getProjectDetails = async (projectId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/projects/${projectId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchUsersDirectory = async (projectId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/projects/${projectId}/users-directory`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // Format users with formatted_role, similar to fetchProjectUsers
  const users = response.data.data || [];
  const formattedUsers = users.map((user) => ({
    ...user,
    formatted_role: convertRole(user?.role),
  }));

  return {
    data: formattedUsers,
    total: response.data.total,
  };
};